import { MAX_ARTIFACT_FILE_SIZE_MESSAGE } from 'configs/fileUpload';
import getApiErrorMessage from 'services/getApiErrorMessage';

const GENERIC_ERROR = 'Unable to upload the artifact. Please try again.';
const CONNECTION_ERROR = 'Upload failed. Check your connection and try again.';

const getUploadErrorMessage = (error, fallback = GENERIC_ERROR) => {
  const response = error && error.response;

  if (response && response.status === 413) return MAX_ARTIFACT_FILE_SIZE_MESSAGE;

  if (error && error.message === 'Network Error') return CONNECTION_ERROR;

  return getApiErrorMessage(error, fallback);
};

export default getUploadErrorMessage;
